export default "__VITE_ASSET__B$pe$6qZ__"